module.exports = __webpack_public_path__ + "static/img/row2.6db0921.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row2.png
// module id = JTJ4
// module chunks = 12